import React, { useEffect } from "react";
import LoacationMaps from "../listing-ceation/TitleAndDesc/location-map";
import ContactAgent from "../listing-ceation/MarketingAssests/contact-agent";
import Amenities from "./amenities";
import { PropertyDetailsObj } from "../../Models/PropertyDetailsObj";
import CountryDetails from "./country-details";
import PropertyInformation from "./property-information";
import DescriptionDetails from "./description-details";
import DescriptionWithReadMore from "./desc-with-read-more";
import { useTranslation } from "react-i18next";

const PropertyDesc: React.FunctionComponent<{ property: PropertyDetailsObj, lang: any }> = (props) => {


    const { t } = useTranslation();

    const getDescriptionByLang = (lang: string) => {
        const descList = props.property?.content?.description;
        if (!Array.isArray(descList)) return "";
        const found = descList.find((item) => item.lang === lang);
        return found ? found.desc : "";
    }

    const getTitleByLang = (lang: string) => {
        const titleList = props.property?.content?.title;
        if (!Array.isArray(titleList)) return "";
        const found = titleList.find((item) => item.lang === lang);
        return found ? found.title : "";
    }

    return props.property ? (
        <>

            <div className="row">
                <div className="col-8 mb-1">
                    <h3 className="title-20 title-18-mb color-black line-height-30">{getTitleByLang(props.lang)}</h3>
                </div>
                <div className="col-4 mb-1">
                    <h3 className="title-20 color-746AFF bold-800 text-end">{Number(props.property?.content?.price?.amount).toLocaleString("en-US")}  {props.property?.content?.price?.currency}</h3>
                </div>
            </div>

            <PropertyInformation property={props.property} />

            <Amenities private_amenities={props.property?.content?.private_amenities} shared_amenities={props.property?.content?.shared_amenities} />

            <h3 className="title-20  mb-4 color-black line-height-30">{t("descriptionDetails.description")}</h3>

            <DescriptionDetails property={props.property} />

            <DescriptionWithReadMore text={getDescriptionByLang(props.lang)} />

            {props.property?.content?.videoTourUrl && <>  <h3 className="title-20 mt-4 mb-4 color-black line-height-30">3D Tour</h3>

                <div className="row">
                    <div className="col-md-8 mb-3">
                        <iframe
                            src={props.property?.content?.view360} frameBorder="0"
                            allowFullScreen
                            className="embed-responsive-item"
                        />
                    </div>
                </div>
            </>}
            {props.property?.content?.videoTourUrl && <><h3 className="title-20  mt-4 mb-4 color-black line-height-30">Video</h3>

                <div className="row">
                    <div className="col-md-8 mb-3">
                        <video
                            src={props.property?.content?.videoTourUrl}
                            controls
                            className="embed-responsive-item"
                        />
                    </div>
                </div>
            </>}
            <CountryDetails property={props.property} />


            <div className="row mt-4 mb-4">
                <div className="col-md-7">
                    <div className="card-form padd-20">
                        <h3 className="title-20 mb-4 color-black line-height-30 ">{t("propertiesPage.location")} </h3>
                        <LoacationMaps position={[props.property?.content?.address?.latitude ?? 0, props.property?.content?.address?.longitude ?? 0]} zoomValue={13} address={props.property?.content?.address} height={270} />
                    </div>
                </div>
                <div className="col-md-5">
                    <div className="card-form padd-15">
                        <h3 className="title-20 color-black  mb-4 line-height-30 ">{t("listingCreation.agentDetails")}</h3>
                        <ContactAgent agent={props.property?.content?.agent} />
                    </div>
                </div>
            </div>

        </>
    ) : null;
};
export default PropertyDesc;
